import { Landmark } from 'lucide-react';

import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';

import { PersonnesMoralesTable } from './PersonnesMoralesTable';

/**
 * Entrée « Compagnies » du menu Acteurs : la liste des personnes morales
 * restreinte à la nature CIE (assureurs, mutuelles, réassureurs — les porteurs
 * de risque). Même tableau et même fiche que les personnes morales.
 */
export default function CompagniesView() {
  return (
    <SimpleDashboardContent>
      <GenericViewHeader title="Compagnies" icon={Landmark} />
      <PersonnesMoralesTable nature="CIE" />
    </SimpleDashboardContent>
  );
}
